import React, { useState, useEffect } from "react";
import foot from "./foot.module.css";
import { FcAdvertising } from "react-icons/fc";
import { TiDocumentText } from "react-icons/ti";
import { FaArrowRight, FaInstagram } from "react-icons/fa";
import { CiFacebook, CiYoutube } from "react-icons/ci";
import { SlSocialTwitter } from "react-icons/sl";
import { PiTelegramLogoLight } from "react-icons/pi";
import { Link } from "react-router-dom";
import { subscribeToNewsletter } from "../../Api/PostManApi";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    let timer;
    if (message) {
      timer = setTimeout(() => {
        setMessage("");
      }, 5000); // Message will disappear after 5 seconds
    }
    return () => clearTimeout(timer); // Clean up on unmount
  }, [message]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage("");

    // Validate email
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setMessage("Please enter a valid email address.");
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await subscribeToNewsletter(email);
      setMessage(response.message || "Thank you for subscribing!");
      if (response.success) {
        setEmail("");
      }
    } catch (error) {
      setMessage("An error occurred. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={foot.foot}>
      <div className={foot.container}>
        <div className={foot.content}>
          <div className={foot.flexI}>
            <div className={foot.secI}>
              <FcAdvertising className={foot.icons} />
              <div className={foot.secII}>
                <h4>Advertise with us</h4>
                <p>
                  <a
                    href="mailto:Promotion@techpression.com"
                    style={{ color: "white" }}
                  >
                    Promotion@techpression.com
                  </a>
                </p>
              </div>
            </div>
            <div className={foot.secI}>
              <TiDocumentText className={foot.icons} />
              <div className={foot.secII}>
                <h4>Send your PR</h4>
                <p>
                  <a
                    href="mailto:news@techpression.com"
                    style={{ color: "white" }}
                  >
                    news@techpression.com
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className={foot.flexII}>
            <h3>Techpression</h3>
            <div className={foot.iconsI}>
              <a
                className={foot.iconsIi}
                href="https://www.instagram.com/techpressionews?igsh=OXBhcXh2bTJtNms3"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our Instagram page"
              >
                <FaInstagram
                  className={foot.iconsIi}
                  style={{ color: "white" }}
                ></FaInstagram>
              </a>
              {/* <a
                className={foot.iconsIi}
                href="https://www.instagram.com/techpressionews?igsh=OXBhcXh2bTJtNms3"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our Instagram page"
              >
                <PiTelegramLogoLight
                  className={foot.iconsIi}
                  style={{ color: "white" }}
                />
              </a> */}

              <a
                className={foot.iconsIi}
                href="https://web.facebook.com/Techpressiontv"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our Facebook page"
              >
                <CiFacebook
                  className={foot.iconsIi}
                  style={{ color: "white" }}
                />
              </a>
              <a
                className={foot.iconsIi}
                href="https://x.com/Techpressionews?t=nC2itf9nt1SzRcibFuL2lg&s=09"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our Facebook page"
              >
                <SlSocialTwitter
                  className={foot.iconsIi}
                  style={{ color: "white" }}
                />
              </a>
              <a
                className={foot.iconsIi}
                href="https://youtube.com/@techpressiontv?si=9UVpx6XnAlux8gc_"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our Youtube page"
              >
                <CiYoutube
                  className={foot.iconsIi}
                  style={{ color: "white" }}
                />
              </a>
            </div>
          </div>
          <div className={foot.flexIII}>
            <p>
              Your daily blog, exclusive news, all in one, latest trends and
              world news. We've got you covered don't be left out and discover
              news around you or around the world
            </p>
          </div>
          {/*TO BE WORKED ON LATER}

          {/* <div className={foot.flexIV}>
            <div className={foot.gridI}>
              <li>
                <Link to="#">Tech TV</Link>
              </li>
              <li>
                <Link to="#">Events</Link>
              </li>
              <li>
                <Link to="#">Politics</Link>
              </li>
              <li>
                <Link to="#">Health</Link>
              </li>
              <li>
                <Link to="#">World</Link>
              </li>
            </div>
            <div className={foot.gridII}>
              <li>
                <Link to="#">Entertainments</Link>
              </li>
              <li>
                <Link to="#">Finance</Link>
              </li>
              <li>
                <Link to="#">Sport news</Link>
              </li>
              <li>
                <Link to="#">Startup business</Link>
              </li>
              <li>
                <Link to="#">Trending news</Link>
              </li>
            </div>
          </div> */}
          <div className={foot.flexV}>
            <h4>Signup Newsletter</h4>
            <form className={foot.secIi} onSubmit={handleSubmit}>
              <input
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                type="email"
                name="email"
                placeholder="Enter your email"
                required
              />
              <button
                type="submit"
                className={foot.submitButton}
                disabled={isSubmitting}
              >
                Submit <FaArrowRight className={foot.arrowIcon} />
              </button>
            </form>
            {message && (
              <div
                className={`${foot.message} ${
                  message.includes("Thank you") ? foot.success : foot.error
                }`}
              >
                {message}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
